import { render } from "./InsuredsTable.vue?vue&type=template&id=69427f68&scoped=true"
import script from "./InsuredsTable.vue?vue&type=script&lang=js"
export * from "./InsuredsTable.vue?vue&type=script&lang=js"

import "./InsuredsTable.vue?vue&type=style&index=0&id=69427f68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69427f68"]])

export default __exports__